import React from "react"
import { FaFacebookF, FaInstagram } from "react-icons/fa"

// Styles
import styles from "../styles/components/footer.module.scss"

const Footer = () => {
  const date = new Date()
  return (
    <footer className={styles.footer}>
      <div className={styles.social}>
        <a
          aria-label="Lifetime Fitness on Facebook"
          href="https://www.facebook.com/Lifetime-Fitness-422919781093919/"
          target="blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF />
        </a>
        <a
          aria-label="Lifetime Fitness on Instagram"
          href="https://www.instagram.com/lifetime.fitness.by.maduranga/"
          target="blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </a>
      </div>
      <p>
        Copyright {date.getFullYear()} Lifetime Fitness. All Rights Reserved.
      </p>
      <div className={styles.mobile}>
        <a
          aria-label="Lifetime Fitness on Facebook"
          href="https://www.facebook.com/Lifetime-Fitness-422919781093919/"
          target="blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF />
        </a>
        <a
          aria-label="Lifetime Fitness on Instagram"
          href="https://www.instagram.com/lifetime.fitness.by.maduranga/"
          target="blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </a>
      </div>
    </footer>
  )
}

export default Footer
